module.exports = __webpack_public_path__ + "static/media/3.4_preview.eec014cb.png";